import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import isEqual from 'lodash/isEqual';

import UgcBox from './UgcBox.component';
import Content from './content';
import { isComponentFullScreen, isComponentVisible, shouldComponentBeDeleted } from './utils';
import * as actions from '../../../../actions';

class UgcVisualization extends React.Component {
	static propTypes = {
		messages: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.string,
			message: PropTypes.string,
			user: PropTypes.object,
		})),
		dispatch: PropTypes.func.isRequired,
	};

	static defaultProps = {
		messages: null,
	};

	constructor(props) {
		super(props);
		this.isComponentFullScreen = isComponentFullScreen.bind(this);
		this.isComponentVisible = isComponentVisible.bind(this);
		this.shouldComponentBeDeleted = shouldComponentBeDeleted.bind(this);
	}

	componentDidMount() {
		const { dispatch } = this.props;
		dispatch({ type: actions.submission.SUBMISSION_INIT });
	}

	shouldComponentUpdate(nextProps) {
		const selectedTheSame = isEqual(sortBy(this.props.selected), sortBy(nextProps.selected));
		const focussedTheSame = this.props.focussed === nextProps.focussed;
		return !focussedTheSame || !selectedTheSame;
	}

	render() {
		const { messages, focussed } = this.props;
		return (
			<Content>
				{messages.map((message, idx) => {
					const {
						user, username, id, url, type,
					} = message;
					const userWithFallback = user || { username: 'Anonymous' };
					return (
						<UgcBox
							willBeDeleted={this.shouldComponentBeDeleted(id)}
							show={this.isComponentVisible(id)}
							fullscreen={this.isComponentFullScreen(id)}
							user={username || userWithFallback.username || userWithFallback.name}
							url={url}
							key={id}
							id={id}
							idx={idx}
							type={type}
							messageCount={messages.length}
							focussed={focussed}
						/>
					);
				})
				}
			</Content>
		);
	}
}

export default UgcVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/ugcvisualization/UgcVisualization.component.js